import './index.less';

console.log('Page Builder Frontend Loaded');

import('./component/document/documentjs.js');
import('./component/form-components/simple/color-picker/color-picker.js');
import('./component/form-components/simple/color-search/color-search.js');

const componentList = [
    {
        name: 'ImageCommon',
        selector: '.link-image',
        load: () => import(/* webpackChunkName: "image" */'./component/image/image-common'),
        init: 'init',
    },
    {
        name: 'FormCommon',
        selector: '.form-component',
        load: () => import(/* webpackChunkName: "form" */'./component/form-components/form/form-common'),
        init: 'initForms',
    },
    {
        name: 'PressReleaseCommon',
        selector: '.press-release-download-all',
        load: () => import(/* webpackChunkName: "press-release" */'./component/press-releases/press-release-common'),
        init: 'init',
    },
    {
        name: 'ProductsSearchCommon',
        selector: '.search-container.products input#findProduct',
        load: () => import(/* webpackChunkName: "products-search" */'./component/products-a-z/products-search-common'),
        init: 'init',
    },
    {
        name: 'ProductsAZ',
        selector: '[data-product-category-page]',
        load: () => import(/* webpackChunkName: "products-az" */'./component/products-a-z/products-az-common'),
        init: 'ProductAZCommon.init',
    },
    {
        name: 'ProductDetailColorSearchCommon',
        selector: '.search-container input#colorCode',
        load: () => import(/* webpackChunkName: "product-detail-color-search" */'./component/products-a-z/product-detail-color-search-common'),
        init: 'init',
    },
    {
        name: 'initBillboardCarousel',
        selector: '[id^=billboard-carousel-]',
        load: () => import(/* webpackChunkName: "billboard-carousel" */'./component/billboard-carousel/billboard-carousel-frontend')
    },
    {
        name: 'BlogSearchCommon',
        selector: '.search-container.blog-search-container input#blogSearch',
        load: () => import(/* webpackChunkName: "blog-search" */'./blog/blog-search'),
        init: 'init',
    },
    {
        name: 'CalculatorColorSearchCommon',
        selector: '.calculator-color-search-container input#colorCode',
        load: () => import(/* webpackChunkName: "calculator-color-search" */'./component/products-a-z/calculator-color-search-common'),
        init: 'initAll',
    },
    {
        name: 'TimelineCommon',
        selector: '.timeline-selectable',
        load: () => import(/* webpackChunkName: "timeline" */'./component/timeline/timeline-common'),
        init: 'init',
    },
    {
        name: 'RepeatableFieldGroupFrontend',
        selector: '.repeatable-component',
        load: () => import(/* webpackChunkName: "repeatable-field-group" */'./component/form-components/simple/repeatable-field-group/repeatable-field-group-frontend'),
        init: 'init',
    },
    {
        name: 'faqComponentJS',
        selector: '.faqs-group-component',
        load: () => import(/* webpackChunkName: "faq-group" */'./component/faq/faq-common'),
        init: 'init',
    },
    {
        name: 'AccordionCommon',
        selector: '.accordion-component',
        load: () => import(/* webpackChunkName: "accordion" */'./component/accordion/accordion-common'),
        init: 'initAll',
    },
    {
        name: 'AccordionV2Common',
        selector: '.accordion-v2-component',
        load: () => import(/* webpackChunkName: "accordion-v2" */'./component/accordion-v2/accordion-v2-common'),
        init: 'initAll',
    },
    {
        name: 'CardSectionService',
        selector: '.dnd-editor-parent .card-section-component, .dnd-editor-parent .boxes-component, .dashboard-container .grid.dashboard',
        load: () => import(/* webpackChunkName: "card-section" */'./component/card-section/card-section-common'),
        init: 'initSection',
        delay: window.innerWidth > 768 ? 600 : 800
    },
    {
        name: 'CountryCardCommon',
        selector: '.country-card-component',
        load: () => import(/* webpackChunkName: "country-card" */'./component/country-card/country-card-common'),
        init: 'init',
    },
    {
        name: 'ColorsCommon',
        selector: '.color-card-component',
        load: () => import(/* webpackChunkName: "color-card" */'./component/color-card/color-common'),
        init: 'init',
    },
    {
        name: 'CarouselUniversalFrontend',
        selector: '.carousel-universal-component',
        load: () => import(/* webpackChunkName: "carousel-universal" */'./component/carousel-universal/carousel-universal-frontend'),
        init: 'init',
    },
    {
        name: 'BoxesFrontend',
        selector: '.boxes-component',
        load: () => import(/* webpackChunkName: "boxes" */'./component/boxes/boxes-frontend'),
        init: 'init',
    },
    {
        name: 'CarouselFrontend',
        selector: '.carousel-component .component-carousel',
        load: () => import(/* webpackChunkName: "carousel" */'./component/carousel/carousel-frontend'),
        init: 'init',
    },
    {
        name: 'iframeFrontend',
        selector: 'iframe',
        load: () => import(/* webpackChunkName: "iframe" */'./component/iframe/iframe-frontend'),
        init: 'init',
    },
    {
        name: 'ProductsCommon',
        selector: '.product-card-component [data-details-url]',
        load: () => import(/* webpackChunkName: "product-card" */'./component/product-card/product-common'),
        init: 'init',
    },
    {
        name: 'SiteSearchCommon',
        selector: 'input.site-search:not(.tt-input):not(.tt-hint)',
        load: () => import(/* webpackChunkName: "site-search" */'./site-search/site-search'),
        init: 'init',
    }
];

var components = {};

async function loadComponent(c, element) {
    const { name, selector, load, init, delay } = c;
    //console.log('#####', 'Loading component:', c, 'element: ', element);

    if (delay) {
        await new Promise(resolve => setTimeout(resolve, delay));
    }

    const roots = element ? [element] : Array.from(document.querySelectorAll(selector));

    if (!roots.length) return;

    components[name] = {
        selector: selector,
        containers: roots.length,
        initialized: false,
        loadTime: Date.now(),
        delay: delay || 0
    };

    components[name].loaded = false

    if (!c.module) {
        c.module = await load();
        components[name].loaded = true
        console.log(name + ' script loaded %c successfully', 'color: green');
        components[name].loadTime = Date.now() - components[name].loadTime;
    }

    components[name].elements = roots;

    roots.forEach((root) => {
        try {
            if (!init) {
                c.module[name](root);
            }
            else {
                let tmp = init.split('.')
                if (tmp.length === 2) {
                    c.module[name][tmp[0]][tmp[1]](root);
                } else {
                    //console.log('????',name, init, c.module(), module);
                    c.module[name][init](root);
                }
            }
            components[name].initialized = true;
            c.initialized = true;
            console.log(name + ' run %c successfully', 'color: green', root);
            //console.table(components);
        } catch (e) {
            console.error('  error:', e);
        }
    });
}

async function bootstrapSections() {
    await Promise.all(
        componentList.filter(c => !c['module']).map(c => loadComponent(c, null))
    );
    //console.table(components);
}

//bootstrapSections();
setDomObserver();

function setDomObserver() {
    const seen = new WeakSet();
    let debounceTimer = null;

    function check(root: ParentNode | Element = document) {
        componentList.forEach(comp => {
            let selector = comp.selector;
            const elements: Element[] =
                root instanceof Element
                    ? [
                        ...(root.matches(selector) ? [root] : []),
                        ...Array.from(root.querySelectorAll(selector))
                    ]
                    : Array.from(root.querySelectorAll(selector));

            for (const el of elements) {
                if (seen.has(el)) continue;
                seen.add(el);
                loadComponent(comp as any, el)
            }
        })
    }
    // első futás
    check();

    const pendingNodes: Element[] = [];

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of Array.from(mutation.addedNodes)) {
                if (node instanceof Element) pendingNodes.push(node);
            }
        }
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            const nodes = pendingNodes.splice(0);
            nodes.forEach(node => check(node));
        }, 50);
    });


    observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        //attributes: true,
        //attributeFilter: ['class', 'id', 'data-track']
    });
}